import React, { Fragment } from "react";
import { Table, Button } from "react-bootstrap";

// --------------------------------------------------------------------
//
//  ProfessorHomeForm
//
// --------------------------------------------------------------------

export const CourseForm = ({ isAdmin, courses, handleView }) => {
  const column_max = 3;

  let rowHeader = [];
  for (let i = 0; i < column_max; i++) {
    rowHeader.push(
      <Fragment key={i}>
        <th>교과 번호</th>
        {isAdmin ? <th>교수 이름</th> : null}
        <th style={{ visibility: "hidden" }}>보기</th>
      </Fragment>
    );
  }

  let rowCourses = [];
  if (courses) {
    let temp = [];
    for (let i = 0; i < courses.length; i += column_max) {
      temp.push(courses.slice(i, i + column_max));
    }

    rowCourses = temp.map((it, index) => {
      return (
        <tr key={index}>
          {it.map((st, sIndex) => {
            return (
              <Fragment key={sIndex}>
                <td>{st.courseNumber}</td>
                {isAdmin ? <td>{st.professorName}</td> : null}
                <td>
                  <Button
                    size="sm"
                    onClick={handleView}
                    name="id"
                    value={st.id}
                  >
                    보기
                  </Button>
                </td>
              </Fragment>
            );
          })}
        </tr>
      );
    });
  } else {
    return <Fragment></Fragment>;
  }

  return (
    <Fragment>
      <Table variant="striped">
        <thead>
          <tr>{rowHeader}</tr>
        </thead>
        <tbody>
          {rowCourses ?? (
            <tr>
              <td>데이타가 없습니다.</td>
            </tr>
          )}
        </tbody>
      </Table>
    </Fragment>
  );
};
